appSocial.controller('leadersPage', ['$scope', '$state', '$ionicModal', 'SocialLocaleService', 'SocialUtils', 'LeadersCompareService',
    function ($scope, $state, $ionicModal, SocialLocaleService, SocialUtils, LeadersCompareService) {
        class LeadersPage {
            constructor() {
                this.translation = SocialLocaleService.translation;
                this.$scope = $scope;
                this.$state = $state;
                this.utils = SocialUtils;
                this.compareService = LeadersCompareService;

                this.categories = [
                    {
                        id: 'all',
                        title: 'allCategories',
                        active: true,
                        show: true
                    },
                    {
                        id: 'editors-choice',
                        title: 'editorsChoice',
                        active: false,
                        show: true
                    },
                    {
                        id: 'most-copied',
                        title: 'mostCopied',
                        active: false,
                        show: true
                    },
                    {
                        id: 'profitable',
                        title: 'mostProfitable',
                        active: false,
                        show: true
                    },
                    {
                        id: 'trending',
                        title: 'trending',
                        active: false,
                        show: true
                    },
                    {
                        id: 'top',
                        title: 'topInvestors',
                        active: false,
                        show: true
                    },
                    {
                        id: 'custom-search',
                        title: 'customSearch',
                        active: false,
                        show: false
                    }
                ];

                this.modal = null;

                const initialCategory = _.find(this.categories, {id: $state.params.category})
                if (initialCategory) {
                    this.toggleCategory(initialCategory)
                } else {
                    this.updateActiveCategory();
                }

                this.limit = 28;

                $scope.$on('$ionicView.beforeLeave', () => {
                    this.modal && this.modal.remove();
                })

                // $scope.$on('scroll.start', () => {
                //     console.log('start scroll');
                // });
                //
                // $scope.$on('scroll.stop', () => {
                //     console.log('stop scroll');
                // });

                this.isComparing = false;
            }

            initSearchModal() {
                const modal = $ionicModal.fromTemplate(`<leaders-search on-close="$ctrl.modal.hide()"></leaders-search>`, {
                    scope: this.$scope,
                    animation: 'slide-in-up'
                });
                modal.el.classList.add('search-modal-backdrop');
                modal.el.querySelector('.modal-wrapper').classList.add('search-modal');
                return modal;
            }

            toggleCategory(category) {
                console.log('Toggle category', category);
                this.categories.forEach(item => item.active = false);
                category.active = true;
                this.updateActiveCategory();
            }

            updateActiveCategory() {
                this.activeCategory = _.find(this.categories, {active: true});
            }

            openLeadersSearch() {
                if (!this.modal) {
                    this.modal = this.initSearchModal();
                }
                this.modal.show();
            }

            getCategoryById(id) {
                return _.find(this.categories, {id});
            }
        }

        return new LeadersPage()
    }]);

